import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataQuery from "data/DataQuery";
import { Resources_DownloadResource } from "data/endpoints";
import IFileService from "data/IFileService";
import Card from "features/shared/components/card/Card";
import DownloadResourceDTO from "features/shared/dtos/DownloadResourceDTO";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

const SelfReadingDocsSection = () => {
  //DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // tranlations
  const tLabels = useTranslation("selfReadings\\selfReadings").t;
  const email1 = tLabels("selfReadingDocsSection.email1");
  const email2 = tLabels("selfReadingDocsSection.email2");

  // handlers
  const downloadSelfReadingTemplateHandler = () => {
    let fileName = tLabels("selfReadingDocsSection.fileName");

    let resource: DownloadResourceDTO = {
      resourceId: "BulkSelfReadingFile",
      resourceExtension: `.${fileName.split(".").pop()}`,
      fileNameWithExtension: fileName,
    };

    let query: DataQuery = {
      url: Resources_DownloadResource,
      params: new URLSearchParams(resource as any),
    };

    fileService.downloadFile(query);
  };

  // render
  return (
    <Card className="pt-4 px-4 pb-2">
      <div className="mb-3">
        <button
          className="btn btn-primary"
          onClick={downloadSelfReadingTemplateHandler}
        >
          <FontAwesomeIcon icon="file-excel" />
          <span className="ml-2">
            {tLabels("selfReadingDocsSection.downloadTemplate")}
          </span>
        </button>
      </div>
      <Trans
        i18nKey="selfReadingDocsSection.content"
        t={tLabels}
        components={[
          <a href={`mailto:${email1}`}>{{ email1 }}</a>,
          <a href={`mailto:${email2}`}>{{ email2 }}</a>
        ]}
      />
    </Card>
  );
};

export default SelfReadingDocsSection;
